const cards = [
  {
    title: '97视频会员体系全解析',
    desc: '从免费用户到高级会员，97视频的付费层级如何划分？不同等级的权益差异有多大？本文为你逐一拆解。',
    icon: 'ri-vip-crown-line',
    tag: '会员对比',
  },
  {
    title: '丝瓜视频内容分类指南',
    desc: '丝瓜视频的内容分类逻辑清晰，但隐藏的好内容需要技巧才能发现。这里分享几个实用的内容发现方法。',
    icon: 'ri-folder-open-line',
    tag: '使用技巧',
  },
  {
    title: '多平台账号管理建议',
    desc: '同时使用97视频、丝瓜视频、蓝莓视频等多个平台时，如何高效管理账号和订阅？来看看我们的经验整理。',
    icon: 'ri-user-settings-line',
    tag: '效率提升',
  },
  {
    title: '蓝莓视频界面优化测评',
    desc: '蓝莓视频近期更新了播放器和推荐算法，实际体验如何？我们进行了为期一周的深度体验。',
    icon: 'ri-smartphone-line',
    tag: '体验测评',
  },
  {
    title: '91在线视频访问优化',
    desc: '部分地区访问91在线视频可能遇到延迟问题，本文整理了几种有效的网络优化方案供参考。',
    icon: 'ri-speed-up-line',
    tag: '网络优化',
  },
  {
    title: '选择困难症自救手册',
    desc: '面对糖心视频、黑桃视频等众多平台无从下手？三步帮你找到最适合自己的在线视频平台。',
    icon: 'ri-emotion-happy-line',
    tag: '决策辅助',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            图文资讯
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            精选图文资讯
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            覆盖97视频、丝瓜视频等平台的实用指南与深度分析
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 p-5 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${card.icon} text-lg text-primary-600`}></i>
                </div>
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading">
                {card.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}